import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./About.scss";
import PavelPhoto from "../assets/pavel.png";
import VlastaPhoto from "../assets/vlasta.png";
import { useTranslation } from "react-i18next";

interface TeamMember {
  name: string;
  photo: string;
  description: string;
}

// interface Project {
//   title: string;
//   description: string;
// }

const About: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();

  const teamMembers: TeamMember[] = [
    {
      name: "Pavel",
      photo: PavelPhoto,
      description: t("about.teamMembers.pavel.description"),
    },
    {
      name: "Vlasta",
      photo: VlastaPhoto,
      description: t("about.teamMembers.vlasta.description"),
    },
  ];

  // const projects: Project[] = [
  //   {
  //     title: t("about.projects.project1.title"),
  //     description: t("about.projects.project1.description"), 
  //   },
  // ];

  return (
    <Container id="about" className={`py-5 about ${className}`}>
      <Row>
        <Col>
          <h2 className="about-title">{t("about.title")}</h2>
          <p className="about-description">{t("about.description1")}</p>
          <p className="about-description">{t("about.description2")}</p>

          <h3 className="about-team-title">{t("about.teamTitle")}</h3>
          <Row className="about-team">
            {teamMembers.map((member, index) => (
              <Col md={6} className="d-flex" key={index}>
                <Card className="team-member">
                  <Card.Img
                    variant="top"
                    src={member.photo}
                    className="team-photo"
                  />
                  <Card.Body>
                    <Card.Title>{member.name}</Card.Title>
                    <Card.Text>{member.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* <h3 className="about-projects-title">{t("about.projectsTitle")}</h3>
          <Row className="about-projects">
            {projects.map((project, index) => (
              <Col md={6} key={index} className="d-flex">
                <Card className="project-card">
                  <Card.Body>
                    <Card.Title>{project.title}</Card.Title>
                    <Card.Text
                      dangerouslySetInnerHTML={{ __html: project.description }}
                    />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row> */}

          <h3 className="legal-info-title">{t("about.legalInfoTitle")}</h3>
          <div className="legal-info">
            <p><strong>{t("about.legalInfo.company").split(':')[0]}:</strong>{t("about.legalInfo.company").split(':')[1]}</p>
            <p><strong>{t("about.legalInfo.id").split(':')[0]}:</strong>{t("about.legalInfo.id").split(':')[1]}</p>
            <p><strong>{t("about.legalInfo.vat").split(':')[0]}:</strong>{t("about.legalInfo.vat").split(':')[1]}</p>
            <p><strong>{t("about.legalInfo.legalForm").split(':')[0]}:</strong>{t("about.legalInfo.legalForm").split(':')[1]}</p>
            <p><strong>{t("about.legalInfo.business").split(':')[0]}:</strong>{t("about.legalInfo.business").split(':')[1]}</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
